import { EventEmitter } from 'events'

class ChoujianMap extends EventEmitter {
  static apiKey='D2MBZ-UNXKL-LHZPE-ER57V-RIEKQ-K2FMU'

  center={ lat: 34.309615, lng: 108.923302 }
  zoom=15
  map=null
  interactive=true

  markerLayer=null // 标注图层

  constructor (container, lat, lng, interactive = true) {
    super()
    this.center = new window.TMap.LatLng(lat, lng)
    this.interactive = interactive
    this.initMap(container)
  }

  /**
   * 地图初始化
   * @param {*} container
   * @param {*} lat
   * @param {*} lng
   */
  initMap (container) {
    this.map = new window.TMap.Map(container, {
      center: this.center,
      zoom: this.zoom,
      showControl: false
    })

    this.markerLayer = new window.TMap.MultiMarker({
      map: this.map
    })
    if (this.interactive) {
      this.map.on('click', this.onMapClick.bind(this))
    }
  }

  destroy () {
    this.map.destroy()
  }

  /**
   * 地图点击事件
   * @param {*} e
   */
  onMapClick (e) {
    this.emit('click', e.latLng.lat, e.latLng.lng)
    this.addPoint(e.latLng.lat, e.latLng.lng)
  }

  addPoint (lat, lng) {
    const position = new window.TMap.LatLng(lat, lng)
    this.markerLayer.setGeometries([{
      id: 'marker',
      position: position
    }])
  }

  setPoint (lat, lng) {
    this.addPoint(lat, lng)
    this.panTo(lat, lng)
  }

  panTo (lat, lng) {
    this.map.panTo(new window.TMap.LatLng(lat, lng))
  }
}

export default ChoujianMap
